/**
 * The recording or voice card of a selected graph node with the voice's own player in it: what
 * the graph sidebar, the investigation sidebar and the Research entity sheet all render. The
 * pure card stays under `components/` with a slot; this is the one place the slot is filled.
 */
import { AudioEvidenceSection } from '@/components/investigations/entity-detail/AudioEvidenceSection'
import { audioEvidence } from '@/components/investigations/entity-detail/audio-evidence'
import { VoiceClipPlayer } from './VoiceClipPlayer'

export function AudioEvidence({
  caseId,
  labels,
  properties,
  onOpenDocument,
}: {
  caseId: string
  labels: readonly string[]
  properties: Record<string, unknown>
  onOpenDocument: ((documentId: string) => void) | null
}) {
  const evidence = audioEvidence(caseId, labels, properties)
  if (!evidence) return null
  return (
    <AudioEvidenceSection
      caseId={caseId}
      evidence={evidence}
      clip={<VoiceClipPlayer caseId={caseId} evidence={evidence} />}
      onOpenDocument={onOpenDocument}
    />
  )
}
